import React from 'react';
import { Box } from '@chakra-ui/react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

// Register the necessary Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

interface PieChartProps {
  data: Record<string, number>;
  width?: string;
  height?: string;
}

const PieChart: React.FC<PieChartProps> = ({
  data,
  width = '500px',
  height = '400px',
}) => {
  // Convert Record<string, number> to labels and dataset
  const labels = Object.keys(data);
  const values = Object.values(data);

  const total = values.reduce((sum, value) => sum + value, 0);
  const percentages = values.map((value) => ((value / total) * 100).toFixed(2)); // Calculate percentage for each value

  const chartData = {
    labels: labels.map((label, index) => `${label} (${percentages[index]}%)`), // Add percentages to labels
    datasets: [
      {
        data: values,
        backgroundColor: [
          '#FF6384',
          '#36A2EB',
          '#FFCE56',
          '#FF5733',
          '#4CAF50',
        ], // Colors for the chart sections
        hoverBackgroundColor: [
          '#FF5A6B',
          '#58A6D2',
          '#FFDB6B',
          '#FF704D',
          '#66D380',
        ],
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem: any) {
            return `${tooltipItem.label}: ${tooltipItem.raw} (${
              percentages[tooltipItem.dataIndex]
            }%)`;
          },
        },
      },
    },
  };

  return (
    <Box width={width} height={height} margin="auto">
      <Pie data={chartData} options={options} />
    </Box>
  );
};

export default PieChart;
